

  // Fonction asynchrone pour formater le texte après le chargement de la page
  document.addEventListener("DOMContentLoaded", function() {
    // Récupérer le tr avec la classe 'nutrifact_ingredients'
    let row = document.querySelector("tr.nutrifact_ingredients");

    if (row) {
      // Récupérer le td dans ce tr
      let cell = row.querySelector("td");

      if (cell) {
        // Récupérer le texte de l'élément td
        let texte = cell.textContent;

        // Regex pour détecter les chaînes en majuscules de plus de 3 lettres, à l'exception de "CLA"
 
let regex = /\b(?!PHD\b)(?!CLA\b)(?!BCAA\b)(?!EAA\b)(?!EGCG\b)([A-ZÀ-ÿ]{3,})(?![a-zà-ÿ])/gu;
        // Remplacer les chaînes en majuscules par leur version avec balises <b>
        let texteFormatte = texte.replace(regex, '<b>$1</b>');

        // Réinjecter le texte formaté dans l'élément td
        cell.innerHTML = texteFormatte;

        // Afficher le résultat dans la console (optionnel)
       // console.log(texteFormatte);
      } else {
      //  console.log("Aucun <td> trouvé dans le <tr> avec la classe 'nutrifact_ingredients'.");
      }
    } else {
   //  console.log("Élément <tr> avec la classe 'nutrifact_ingredients' non trouvé.");
    }
  });

